import Vue from 'vue'
import dayjs from 'dayjs'
import { carStatus } from '@/constants/car'
import defaultState from './state'

export default {
  initStore(state) {
    Object.assign(state, defaultState)
  },
  setKw(state, kw) {
    Vue.set(state, 'kw', kw)
  },
  setPicked(state, picked) {
    Vue.set(state, 'picked', picked)
  },
  setTask(state, task) {
    Vue.set(state, 'task', task)
  },
  setLastUpdateTime(state, time) {
    Vue.set(state, 'lastUpdateTime', time)
  },
  setSwitchSpeech(state, switchSpeech) {
    Vue.set(state, 'switchSpeech', switchSpeech)
  },
  // bill
  setBillList(state, billList) {
    Vue.set(state, 'billList', billList)
  },
  setBillModal(state, modalDetail) {
    Vue.set(state, 'billModal', modalDetail)
  },
  // HACK: 可以考慮移除
  setBillPaging(state, { currentPage, npp, totalPages, totalEntries }) {
    Vue.set(state.billPaging, 'currentPage', currentPage)
    Vue.set(state.billPaging, 'npp', npp)
    Vue.set(state.billPaging, 'totalPages', totalPages)
    Vue.set(state.billPaging, 'totalEntries', totalEntries)
  },
  setBillPagingNpp(state, npp) {
    Vue.set(state.billPaging, 'npp', npp)
  },
  setBillPagingCurrentPage(state, currentPage) {
    Vue.set(state.billPaging, 'currentPage', currentPage)
  },
  setBillPagingTotalPages(state, totalPages) {
    Vue.set(state.billPaging, 'totalPages', totalPages)
  },
  setBillPagingTotalEntries(state, totalEntries) {
    Vue.set(state.billPaging, 'totalEntries', totalEntries)
  },
  // reserve
  setReserveList(state, reserveList) {
    Vue.set(state, 'reserveList', reserveList)
  },
  setReservePagingNpp(state, npp) {
    Vue.set(state.reservePaging, 'npp', npp)
  },
  setReservePagingCurrentPage(state, currentPage) {
    Vue.set(state.reservePaging, 'currentPage', currentPage)
  },
  setReservePagingTotalPages(state, totalPages) {
    Vue.set(state.reservePaging, 'totalPages', totalPages)
  },
  setReservePagingTotalEntries(state, totalEntries) {
    Vue.set(state.reservePaging, 'totalEntries', totalEntries)
  },
  setReserveCount(state, num) {
    Vue.set(state, 'reserveCount', num)
  },
  setDriverInfo(state, { info, onGetOrderGps, onGps, status }) {
    // info
    if (info) {
      Vue.set(
        state.driverInfo.info,
        'callNumber',
        info.call_number ? info.call_number : '',
      )
      let formatCarYear = ''
      if (info.car_year === '未填寫') {
        formatCarYear = '未填寫'
      } else if (info.car_year === 0) {
        formatCarYear = '<1年'
      } else {
        formatCarYear = `${info.car_year}年`
      }
      Vue.set(state.driverInfo.info, 'carYear', formatCarYear)
      Vue.set(state.driverInfo.info, 'carLicense', info.licence) // 後端licence 拼錯，應該是license
      Vue.set(
        state.driverInfo.info,
        'carStatus',
        carStatus[info.status] || '失聯',
      )
      Vue.set(state.driverInfo.info, 'name', info.name)
      Vue.set(
        state.driverInfo.info,
        'serviceList',
        info.service_list
          ? info.service_list.map((service) => service.name).join(',')
          : '',
      )
      Vue.set(state.driverInfo.info, 'gender', info.gender ? '女' : '男')
      Vue.set(state.driverInfo.info, 'brand', info.car_brand)
      Vue.set(state.driverInfo.info, 'phone', info.account)
      Vue.set(state.driverInfo.info, 'note', info.note ? info.note : '')
      Vue.set(
        state.driverInfo.info,
        'updatedAt',
        dayjs(info.updated_at).format('YYYY-MM-DD HH:mm:ss'),
      )
      Vue.set(state.driverInfo.info, 'contact1', info.contact1)
      Vue.set(state.driverInfo.info, 'contact2', info.contact2)
      // HACK: unuse variable
      // Vue.set(state.driverInfo.info, "exclusiveService", info.exclusive_service);
    }
    // order gps
    Vue.set(state.driverInfo, 'onGetOrderGps', onGetOrderGps)
    // on gps
    Vue.set(state.driverInfo, 'onGps', onGps)
    // status
    Vue.set(state.driverInfo, 'status', status)
  },
}



// WEBPACK FOOTER //
// ./src/store/hailState/mutations.js